import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Breadcrumb extends Component {
    render() {
        return (
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb pl-0">
                    <li className="onRight"><Link to="#"><i className="material-icons"></i> {'ראשי > '}</Link></li>
                    <li className="onRight spacePadRight active" aria-current="page">כל העסקים</li>
                </ol>
            </nav>
        );
    }
}

export default Breadcrumb;